export default __webpack_public_path__ + "static/media/image_16.55a5f4d9.png";